import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type SetAuthSecretCodeOperation = paths['/executor_web/auth/secret_code']['post'];

export type SetAuthSecretCodeRequestBody = NonNullable<
	NonNullable<SetAuthSecretCodeOperation['requestBody']>['content']['application/json']
>;
export interface SetAuthSecretCodeRequest extends SetAuthSecretCodeRequestBody {
	token: string;
}
export type SetAuthSecretCodeResponse = SetAuthSecretCodeOperation['responses'][200]['content']['application/json'];
export type SetAuthSecretCodeErrorResponse =
	SetAuthSecretCodeOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/auth/secret_code` — см. `paths['/executor_web/auth/secret_code']` в auth swagger */
export function setAuthSecretCode(request: SetAuthSecretCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<SetAuthSecretCodeResponse>('auth/secret_code', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
